import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { ImageAndProductType } from "@swo/storefront";
import { SwarovskiLink } from "../_shared-components/ui-elements/SwarovskiLink";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../styles/breakpoints";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import React from "react";
import { ContentfulImage } from "../_shared-components/image-related/ContentfulImage";

export const ImageAndProductProductCard: ReactTFC<{ product: NonNullable<ImageAndProductType["product"]> }> = props => {
  return (
    <SwarovskiLink
      className={"product-card"}
      link={props.product.link}
      isInternal={true}
      scrollToTop={true}
      css={css`
        ${CSS_MQ.atLeastLg} {
          position: absolute;
          z-index: 1;

          top: calc(-1 * (var(--size)));
        }

        ${CSS_MQ.atMostMd} {
          display: inline-block;
          order: -1;
        }

        width: var(--size);
        height: var(--size);

        padding: var(--spacing);
        margin-top: var(--m);

        background-color: ${CSS_COLORS.GreenWhite};
      `}
    >
      <ContentfulImage
        assetId={props.product.image.sys.id}
        contentfulLink={{
          requestedWidth: 160,
          url: props.product.image.url,
          noTransparentBackground: false,
        }}
        higherDPI={[2]}
        alt={props.product.image.description || props.product.image.title || undefined}
        css={css`
          width: 100%;
          height: 100%;
          object-fit: contain;
        `}
      />
    </SwarovskiLink>
  );
};
